export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: '瓜田快报主要更新哪些内容？',
    answer:
      '我们专注私拍吃瓜名场面与抓拍盘点，覆盖综艺、舞台、直播、采访、红毯和幕后花絮六个方向。每一条内容都会拆出关键画面时间点，并把神操作、尴尬瞬间、高光瞬间分别标注出来，方便你按兴趣挑着看。',
  },
  {
    question: '「私拍吃瓜名场面」是怎么分类的？',
    answer:
      '分类依据是名场面发生的场景，而不是热度。同一场活动里，台前的高光归入舞台高光，后台的松弛片断归入幕后花絮，直播里没法重来的意外归入直播抓拍。这样分类的好处是：当你想找某一类情绪时，不用在混杂的列表里翻。',
  },
  {
    question: '怎样才能快速定位到某个关键画面？',
    answer:
      '每条名场面详情页顶部都有一份「关键画面目录」，按时间顺序列出最值得看的几个节点，标注了大致时间点和一句话说明。点标题进入详情页后，直接看目录里时间最早的三个节点，通常就能抓住整段内容的核心。',
  },
  {
    question: '内容会不会反复推荐旧瓜？',
    answer:
      '首页默认按收录时间倒序展示，新内容优先。只有当你主动进入某个分类或使用搜索时，才可能看到较早的条目。我们尽量让每一次打开首页都有新东西，而不是把同一条反复推到最前面。',
  },
  {
    question: '可以投稿或者提供线索吗？',
    answer:
      '可以。你可以通过页面底部的邮箱联系我们，简单说明是哪一个场景、大概的时间点以及为什么值得记录。我们更看重「画面本身有信息量」，而不是单纯的争议话题。',
  },
  {
    question: '网站上的内容可以转载吗？',
    answer:
      '站内的文字整理和分类结构是我们原创的，转载时请注明来源。涉及到的画面版权归原发布方所有，我们只做观看顺序上的整理与说明，不做二次商用。',
  },
];